import { render, staticRenderFns } from "./PopupAddTableCombination.vue?vue&type=template&id=381b3210&scoped=true&"
import script from "./PopupAddTableCombination.vue?vue&type=script&lang=js&"
export * from "./PopupAddTableCombination.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddTableCombination.vue?vue&type=style&index=0&id=381b3210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381b3210",
  null
  
)

export default component.exports